import * as React from "react";
import { cn } from "../../lib/cn";
import type { NavItem } from "./types";
import type { RenderLinkFn } from "./Sidebar";

export interface NavigationProps {
  items: NavItem[];
  orientation?: "horizontal" | "vertical";
  renderLink: RenderLinkFn;
  className?: string;
}

/** Standalone nav list — used inside Sidebar or as a top nav */
export function Navigation({ items, orientation = "vertical", renderLink, className }: NavigationProps) {
  return (
    <nav className={cn(orientation === "horizontal" ? "flex items-center gap-1" : "flex flex-col gap-0.5", className)}>
      {items.map((item) => {
        const { to, label, icon: Icon, end, badge } = item;
        return (
          <React.Fragment key={to}>
            {renderLink({
              to,
              end,
              className: ({ isActive }: { isActive: boolean }) =>
                cn(
                  "flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium transition-colors",
                  isActive
                    ? "bg-indigo-50 text-indigo-700"
                    : "text-gray-600 hover:text-gray-900 hover:bg-gray-100",
                ),
              children: (
                <>
                  {Icon && <Icon className="w-4 h-4 flex-shrink-0" />}
                  {label}
                  {badge != null && badge > 0 && (
                    <span className="ml-auto flex h-4 min-w-4 items-center justify-center rounded-full bg-indigo-500 px-1.5 text-[10px] font-medium text-white">
                      {badge > 99 ? "99+" : badge}
                    </span>
                  )}
                </>
              ),
            })}
          </React.Fragment>
        );
      })}
    </nav>
  );
}
